import { useRef } from 'react';

import BurgerIcon from 'assets/icons/burger.svg';
import cn from 'classnames/bind';
import { useToggleState, useClosableModal } from 'hooks';
import { CSSTransition } from 'react-transition-group';
import CloseMenu from 'ui/components/menu/CloseMenu';
import Portal from 'ui/layouts/Portal';

import s from './MobileNavigation.module.scss';

const cx = cn.bind(s);

const MobileNavigation = ({
  children,
  className,
  dense = false,
  shouldCloseOnIconClick = true,
  onClose,
  onCloseIconClick,
  ...attrs
}) => {
  const {
    isActive,
    close,
    toggle,
  } = useToggleState(false);

  useClosableModal({
    onUrlChanged: close,
    onClose: close,
    isActive,
  });

  const handleClick = (ev) => {
    if (ev.target === ev.currentTarget) {
      close();
    }
  };
  const handleCloseIconClick = () => {
    if (shouldCloseOnIconClick) {
      close();
    } else {
      onCloseIconClick?.();
    }
  };
  const handleExited = () => {
    onClose?.();
  };
  const containerRef = useRef();
  return (
    <>
      <button className={cx(className, 'button')} {...attrs} onClick={toggle}>
        <BurgerIcon />
      </button>
      <Portal>
        <CSSTransition
          nodeRef={containerRef}
          in={isActive}
          timeout={150}
          unmountOnExit
          mountOnEnter
          classNames={{
            enter: cx('enter'),
            enterActive: cx('enterActive'),
            exit: cx('exit'),
            exitActive: cx('exitActive'),
          }}
          onExited={handleExited}
        >
          <div ref={containerRef} className={cx('drawerContainer')} onClick={handleClick}>
            <div className={cx('drawer')}>
              <div className={cx('drawerContent', { drawerDense: dense })}>
                <CloseMenu
                  onClose={handleCloseIconClick}
                />
                {typeof children === 'function' ? children({ isActive, close }) : children}
              </div>
            </div>
          </div>
        </CSSTransition>
      </Portal>
    </>
  );
};

export default MobileNavigation;
